import t from "@constants/localization";

const DELIVERY_PATH = "screens/MyDeliveries/DeliveryReturn/DeliveryCard";
const PATH = "screens/MyDeliveries/DeliveryReturn/OverView";

export const getItemsNotReturnedText = (returnDetails = {}) => {
  if (returnDetails.cratesNotReturned && returnDetails.itemsNotReturned) {
    return `${returnDetails.cratesNotReturned} ${t(`${PATH}/crate`)}, ${returnDetails.itemsNotReturned} ${t(`${PATH}/item`)} ${t(`${PATH}/notReturned`)}`;
  } else if (returnDetails.cratesNotReturned) {
    return `${returnDetails.cratesNotReturned} ${t(`${PATH}/crate`)} ${t(`${PATH}/notReturned`)}`;
  } else if (returnDetails.itemsNotReturned) {
    return `${returnDetails.itemsNotReturned} ${t(`${PATH}/item`)} ${t(`${PATH}/notReturned`)}`;
  }
  return `${t(`${PATH}/notReturned`)}`;
};

export const getUnableToDeliverText = (unableToDeliver = {}) => {
  if (unableToDeliver.noOfCrates && unableToDeliver.noOfShipments && unableToDeliver.noOfOpenItems) {
    return `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)}, ${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)}, ${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)} ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  } else if (unableToDeliver.noOfCrates && unableToDeliver.noOfShipments) {
    return `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)}, ${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)} ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  } else if (unableToDeliver.noOfCrates && unableToDeliver.noOfOpenItems) {
    return `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)}, ${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)} ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  } else if (unableToDeliver.noOfShipments && unableToDeliver.noOfOpenItems) {
    return `${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)}, ${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)} ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  } else if (unableToDeliver.noOfCrates) {
    return `${unableToDeliver.noOfCrates} ${t(`${DELIVERY_PATH}/crate`)} ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  } else if (unableToDeliver.noOfShipments) {
    return `${unableToDeliver.noOfShipments} ${t(`${DELIVERY_PATH}/packets`)} ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  } else if (unableToDeliver.noOfOpenItems) {
    return `${unableToDeliver.noOfOpenItems} ${t(`${DELIVERY_PATH}/items`)} ${t(`${DELIVERY_PATH}/notDelivered`)}`;
  }
  return `${t(`${DELIVERY_PATH}/notDelivered`)}`;
};

export const getCrateListFromCrateIds = (list) => {
  return list && Array.isArray(list)
    ? list.map((id) => {
      return `${t(`${DELIVERY_PATH}/crate`)} - ${id}`;
    })
    : [];
};
